import { v4 as uuidv4 } from 'uuid';
import { removeScheduleAPI } from './api';
import { getStore } from '../../factory';

export async function deleteSchedule(subscription, schedule) {
    const session = this.env.session;
    const traceId = this.env.traceId;

    this.env.startLoadCounter({ target: 'appProgress' });
    this.loadingList[schedule.scheduleId] = true;
    this.observed.loadingList = uuidv4();

    try {
        const res = await removeScheduleAPI({
            body: { calendarIds: [schedule.scheduleId] },
            store: this,
            token: session.token,
            traceId,
            subscriptionId: subscription.id,
        });

        if (res?.error) return { success: false };

        const subscriptionsStore = getStore('subscriptions');

        const existingConnected = subscriptionsStore.connectedSchedules[subscription.id] || [];
        const existingAvailable = subscriptionsStore.availableSchedules[subscription.id] || [];

        subscriptionsStore.connectedSchedules = {
            ...subscriptionsStore.connectedSchedules,
            [subscription.id]: existingConnected.filter(
                (s) => s.scheduleId !== schedule.scheduleId && s.id !== schedule.scheduleId
            ),
        };
        subscriptionsStore.availableSchedules = {
            ...subscriptionsStore.availableSchedules,
            [subscription.id]: [...existingAvailable, schedule],
        };
        subscriptionsStore.observed.availableSchedules = uuidv4();
        subscriptionsStore.cardSignals.set(subscription.id, uuidv4());

        await subscriptionsStore.getAvailableSchedules(subscription.id);

        this.deleteList.push(schedule);
        this.observed.deleteList = uuidv4();

        return { success: true };
    } catch {
        return { success: false };
    } finally {
        this.env.stopLoadCounter();
        delete this.loadingList[schedule.scheduleId];
        this.observed.loadingList = uuidv4();
    }
}

export function removeItemFromDeletelist() {
    this.deleteList.pop();
}
